module.exports = __webpack_public_path__ + "img/gc4.04a6f78a.png";